
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.5 16h-19A2.503 2.503 0 010 13.5v-11C0 1.122 1.122 0 2.5 0h19C22.878 0 24 1.122 24 2.5v11c0 1.378-1.122 2.5-2.5 2.5zM2.5 1C1.673 1 1 1.673 1 2.5v11c0 .827.673 1.5 1.5 1.5h19c.827 0 1.5-.673 1.5-1.5v-11c0-.827-.673-1.5-1.5-1.5h-19z"}}),_c('path',{attrs:{"d":"M12 9.017c-.55 0-1.101-.164-1.581-.493L2.218 2.913a.5.5 0 01.564-.825l8.201 5.611a1.79 1.79 0 002.033 0l8.201-5.611a.5.5 0 01.565.825l-8.201 5.611A2.792 2.792 0 0112 9.017zM2.5 14a.5.5 0 01-.321-.885l6-5a.5.5 0 01.641.769l-6 5A.497.497 0 012.5 14zm19 0a.499.499 0 01-.32-.116l-6-5a.5.5 0 01.641-.769l6 5A.5.5 0 0121.5 14z"}})])
          )
        }
      }
    